export default __webpack_public_path__ + "static/media/fun_may2020_pt1.dcb6d13e.bmp";